// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ALL_COUNTIES = "V\u0161etky okresy";
export const SETTINGS_I_LIVE_ABROAD = "\u017dijem v zahrani\u010d\u00ed...";
export const USERS_DIRECTORY_SHE_LIVES_ABROAD = "\u017dije v zahrani\u010d\u00ed...";
